import React from 'react';
import { Location } from '@gatsbyjs/reach-router';
import type { FacilityProps } from './facility-content';
import { FacilityContent } from './facility-content';

const Facility = (props: FacilityProps) => (
  <Location>{({ location }) => <FacilityContent {...props} location={location} />}</Location>
);

export default Facility;
